interface TeamCardProps {
  name: string;
  position: string;
  description: string;
}

export function TeamCard({ name, position, description }: TeamCardProps) {
  return (
    <div
      className="mobile-team-card"
      style={{
        display: 'flex',
        padding: '30px 24px',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 'var(--item-spacing-xxs, 4px)',
        justifySelf: 'stretch',
        borderRadius: '18px',
        border: 'var(--stroke-weight-1, 1px) solid rgba(255, 255, 255, 0.05)',
        background: 'rgba(10, 12, 20, 0.90)',
      }}
    >
      {/* Avatar */}
      <div
        style={{
          display: 'flex',
          width: '72px',
          height: '72px',
          justifyContent: 'center',
          alignItems: 'center',
          borderRadius: '36px',
          border:
            'var(--stroke-weight-2, 2px) solid var(--color-azure-6920, rgba(118, 188, 232, 0.20))',
          background:
            'linear-gradient(135deg, var(--color-azure-6912, rgba(118, 188, 232, 0.12)) 0%, var(--color-azure-5712, rgba(74, 156, 216, 0.12)) 100%)',
          marginBottom: '16px',
          flexShrink: 0,
        }}
      />

      {/* Name */}
      <div
        style={{
          color: 'var(--Athens-Gray, var(--color-grey-91, #E2E8F0))',
          textAlign: 'center',
          fontFamily: 'var(--font-family-Font-3, Inter)',
          fontSize: 'var(--font-size-15, 15px)',
          fontStyle: 'normal',
          fontWeight: 'var(--font-weight-700, 700)',
          lineHeight: 'normal',
        }}
      >
        {name}
      </div>

      {/* Position */}
      <div
        style={{
          color: 'var(--Seagull, var(--color-azure-69, #76BCE8))',
          textAlign: 'center',
          fontFamily: 'var(--font-family-Font-3, Inter)',
          fontSize: 'var(--font-size-11, 11px)',
          fontStyle: 'normal',
          fontWeight: 'var(--font-weight-600, 600)',
          lineHeight: 'normal',
          letterSpacing: 'var(--letter-spacing-0_5, 0.5px)',
          textTransform: 'uppercase',
        }}
      >
        {position}
      </div>

      {/* Description */}
      <div
        style={{
          color: 'var(--Boulder, var(--color-grey-46, #6B7280))',
          textAlign: 'center',
          fontFamily: 'var(--font-family-Font-3, Inter)',
          fontSize: 'var(--font-size-12, 12px)',
          fontStyle: 'normal',
          fontWeight: 'var(--font-weight-400, 400)',
          lineHeight: 'var(--line-height-19_2, 19.2px)',
          marginTop: '8px',
        }}
      >
        {description}
      </div>
    </div>
  );
}
